'use strict';

var DropEffects = {
  COPY: 'copy',
  MOVE: 'move',
  LINK: 'link'
};

module.exports = DropEffects;


/*****************
 ** WEBPACK FOOTER
 ** ../~/react-dnd/dist-modules/constants/DropEffects.js
 ** module id = 295
 ** module chunks = 0
 **/